import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const toggleWorkflowStatus = async (workflow) => {
  if (workflow.disabled) {
    await AIAgentDefinitions.enable(workflow.id);
  } else {
    await AIAgentDefinitions.disable(workflow.id);
  }
};
const useToggleWorkflowStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: toggleWorkflowStatus,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: WORKFLOW_DEFINITIONS_QUERY_KEY })
  });
};
export default useToggleWorkflowStatus;
